module.exports = __webpack_public_path__ + "static/img/logo1.41de46e2.png";